import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VCard,
    {
      staticClass: "d-flex justify-space-between align-center py-4 pl-4",
      attrs: { flat: "", tile: "", ripple: { class: "primary--text" } },
      on: {
        click: _setup.handleSwitch,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _setup.handleSwitch.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center" },
        [
          _c(
            VIcon,
            { staticClass: "mr-4", attrs: { color: "icon-secondary" } },
            [_vm._v("\n      ui-icon-flashlight\n    ")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-body-1 text--text" }, [
            _vm._v(
              "\n      " +
                _vm._s(_setup.t("Онлайн-запись", _setup.options)) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(VSwitch, {
        staticClass: "pt-0 mt-0 pl-1",
        attrs: {
          value: _setup.filtersStore.unsavedFilters.isOnlineAppointment,
          "input-value": _setup.filtersStore.unsavedFilters.isOnlineAppointment,
          color: "primary",
          "hide-details": "",
          dense: "",
          inset: "",
        },
        on: { input: _setup.emitChanges },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }